const setRecords = (state, action) => action.records || state;

export default setRecords;
